import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import { sendEeProviderAlert } from 'config/helpers/integrations-lib'
import PaymentMethodSummary from 'components/provider/PaymentMethodSummary'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
// import DirectDebitIcon from '@material-ui/icons/AccountBalance'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import CardElement from 'components/provider/CardElement'
import Loader from 'components/general/Loader'
import config from 'config/api/Config'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe(config.stripeKey)

const useStyles = makeStyles(componentStyles)


function PaymentMethodModal(props) {
    const api = new ProviderAPI()
    //const details = props.details || {}
    const companyDetails = props.companyDetails

    //const [paymentMethod, setPaymentMethod] = useState(details.paymentMethod || null)
    const [paymentMethod, setPaymentMethod] = useState('Card') // force Card as default
    const [clientSecretCard, setClientSecretCard] = useState(null)
    // const [clientSecretSepa, setClientSecretSepa] = useState(null) // disabled SEPA
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getSetupIntents()
    }, [])

    async function getSetupIntents() {
        try {   
            const setupIntentSecretCard = await api.getSetupIntent(companyDetails.companyId, 'card');
            console.log('setup intent secret card: ', setupIntentSecretCard)

            // SEPA disabled for now
            // const setupIntentSecretSepa = await api.getSetupIntent(companyDetails.companyId, 'sepa_debit');
            // console.log('setup intent secret sepa: ', setupIntentSecretSepa)

            setClientSecretCard(setupIntentSecretCard)
            // setClientSecretSepa(setupIntentSecretSepa)
        } catch(e) {
            onError(e)
        }
        setLoading(false)
    }

    async function setDefaultPaymentMethod(paymentMethodId) {
        try {   
            const response = await api.setDefaultPaymentMethod(companyDetails.companyId, paymentMethodId);
            console.log('response: ', response)

            // Alert: fire once — only when no prior payment method existed
            if (props.isFirstCard) {
                sendEeProviderAlert({ type: 'card_added', company: companyDetails })
            }

            // submit profile and move to main logged in system
            //props.updateStage()
            props.showSuccessAlert('Payment method updated')
            props.onClose()
        } catch(e) {
            onError(e)
        }
    }

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Box component={Typography} variant='h3'>
                            <Box component='span'>Update Payment Method</Box>
                        </Box>
                    </Grid>
                    {loading ? (
                            <Grid item xs={12}>
                                <Box display='flex' justifyContent='center' alignItems='center' style={{height: '10vh'}}>
                                    <Loader />
                                </Box>
                            </Grid>
                    ) : (
                        <>
                            <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                                <Typography variant="body2">
                                    You will not be charged today. Billing runs in arrears — your payment method is charged automatically for leads delivered in the prior billing period. Charges will never exceed your selected lead limit.
                                    <br/><br/>Card payments are processed instantly.
                                </Typography>
                            </Grid>
                            {/* Direct Debit temporarily disabled */}
                            <Grid item xs={12} sm={12} style={{ marginBottom: '2rem' }}>
                                <PaymentMethodSummary 
                                    title='Card'
                                    icon={<CreditCardIcon style={{ height: 30, width: 30, color: '#229626' }} />}
                                    selectedMethod={paymentMethod}
                                    onClick={() => setPaymentMethod('Card')}
                                    active={true}
                                    //discount='5%'
                                    disabled={false}
                                />
                            </Grid>

                            {paymentMethod === 'Card' &&
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormLabel>
                                            Card Details (these are stored securely by Stripe)
                                        </FormLabel>
                                        <FormControl
                                            variant='filled'
                                            component={Box}
                                            width='100%'
                                        >
                                            <Elements
                                                stripe={stripePromise}
                                                options={{
                                                clientSecret: clientSecretCard
                                                }}
                                                key={paymentMethod}
                                            >
                                                <CardElement 
                                                    clientSecret={clientSecretCard}
                                                    setPaymentMethod={setDefaultPaymentMethod}
                                                />
                                            </Elements>
                                        </FormControl>
                                    </FormGroup>
                                </Grid>
                            }
                            
                            {/*!(companyDetails.planDetails && companyDetails.planDetails.plan === 'premium') &&
                                <Grid item xs={12}>
                                    <Box display='flex' justifyContent='flex-end' width='100%'>
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            disabled={loading}
                                            onClick={() => submitPaymentMethod()}
                                        >
                                            {!loading ? (
                                                <>Submit</>
                                            ) : (
                                                <Loader height={12} />
                                            )}
                                        </Button>
                                    </Box>
                                </Grid>
                            */}
                        </>
                    )}
                </Grid>
            </DialogContent> 
        </Dialog>
    );
}

export default PaymentMethodModal